export default __webpack_public_path__ + "static/media/01_photo.f16ece38.jpg";